import { Component, Inject, OnInit, Optional } from '@angular/core';

import { ModalWidgetComponentRef } from '../widget/modal.widget.component';
import { CMPS_WIDGET_MODAL_HANDLE } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    Mi2DetailsPopup,
    Mi2DetailsPopupItem,
    Mi2DetailsPopupItemScorecard,
} from './mi2-details.widget.model';

@Component({
    selector: 'cmps-widget-mi2-details',
    templateUrl: './mi2-details.widget.component.html',
})
export class Mi2DetailsWidgetComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: Mi2DetailsPopup;

    constructor(
        @Optional()
        @Inject(CMPS_WIDGET_MODAL_HANDLE)
        private readonly _modalHandle: ModalWidgetComponentRef,
        private readonly _service: LegacyWidgetService,
    ) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .mi2DetailsPopup()
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    showScorecard(
        item: Mi2DetailsPopupItem,
        scorecard: Mi2DetailsPopupItemScorecard,
    ): void {
        if (this._modalHandle) {
            this._modalHandle.activeModal.close({ item, scorecard });
        }
    }
}
